
import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { MomentSourceType } from '@xt/client/enums/moment'
import UserContentPop from '@xt/www/components/classhour/pop-content/index.vue'
import type { DairyOption } from '@xt/client/entities/course-v2/user-content'
import PublicCourseItem from './PublicCourseItem.vue'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'

@Observer
@Component({
  components: { PublicCourseItem, UserContentPop, InfiniteLoading }
})
export default class VideoPage extends Vue {
  @Ref()
  userContentPop: {
    showPop: (options: DairyOption) => void
    hidePop: () => void
  }
  needLogin: boolean = false

  get body() {
    return {
      sourceType: MomentSourceType.PublicCourse
    }
  }

  get pagePagination() {
    return this.$store.$storeVideoV2.pagePagination
  }

  get PageStore() {
    return this.$store.$storeVideoV2
  }

  handleClick(momentId?: string) {
    if (!momentId || !this.userContentPop) return

    this.userContentPop.showPop({ type: 'dairy', momentId })
  }

  handleOpenLogin() {
    this.needLogin = true
    this.userContentPop.hidePop()
  }

  handleClosed() {
    if (this.needLogin) {
      this.$store.$storeUser.onToggleVisible(true)
      this.needLogin = false
    }
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
